import React from "react";
import style from "./newVoteSwitch.module.css";

type NewVoteSwitchProps = {
    name: string;
    value: boolean;
    onChange: (value: boolean) => void;
};

export function NewVoteSwitch({ name, value, onChange }: NewVoteSwitchProps) {
    return (
        <div className={style.newVoteSlider}>
            <p>{name}</p>
            <label className="switch">
                <input
                    className={style.oneVotePerObjectSwitch}
                    type="checkbox"
                    checked={value}
                    onChange={() => onChange(!value)}
                />
                <span className="slider round" />
            </label>
        </div>
    );
}
